<template>
  <el-date-picker
    v-model="pickerValue"
    :type="type"
    :size="size"
    :readonly="readonly"
    :style="inlineStyle"
    range-separator="По"
    start-placeholder="Дата начала"
    end-placeholder="Дата окончания"
    format="dd-MM-yyyy HH:mm"
    :picker-options="pickerOptions"
  />
</template>

<script>
import {
  formatDateWithoutTimezone,
  formatDateToRFC3339WithoutTimezone,
} from "@/utils";

export default {
  props: {
    value: {
      type: [String, Array, Date],
      required: false,
      default: null,
    },
    type: {
      type: String,
      default: "date",
    },
    size: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    inlineStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  computed: {
    pickerValue: {
      get() {
        // 19 длинна отформатированной даты на фронте
        if (this.value) {
          if (Array.isArray(this.value) && this.value[0] !== 19) {
            return this.value.map((e) => formatDateWithoutTimezone(e));
          }
          if (this.value !== 19) {
            return formatDateWithoutTimezone(this.value);
          }
        }
        return this.value;
      },
      set(val) {
        if (val) {
          Array.isArray(val)
            ? (val = val.map((e) => {
                return formatDateToRFC3339WithoutTimezone(e);
              }))
            : (val = formatDateToRFC3339WithoutTimezone(val));
          this.$emit("input", val);
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
};
</script>
